/* eslint-disable react/destructuring-assignment */
import Icon from './Icon';

const CourseLanguage = (props) => (
  <Icon {...props}>
    <path
      d="M0 9.79536C0 4.66167 4.1982 0.5 9.37695 0.5C14.5557 0.5 18.7539 4.66167 18.7539 9.79536C18.7539 14.9213 14.5674 19.0781 9.3995 19.0907L1.56283 19.0907C1.36364 19.0907 1.20217 18.9307 1.20217 18.7332V14.3573L1.10268 14.173C0.399215 12.8693 0 11.3798 0 9.79536Z"
      fill={props.color}
    />
    <path
      d="M20.8051 10.8707C20.6874 10.6764 20.3973 10.7579 20.3727 10.9838C19.776 16.4714 15.0947 20.7458 9.40346 20.7591L9.40149 20.7591L7.8932 20.7591C7.68451 20.7591 7.57834 21.0043 7.72884 21.1489C9.23916 22.5999 11.2965 23.4947 13.5646 23.5L20.02 23.5C20.5667 23.5 21.01 23.0606 21.01 22.5186V19.0871C21.6418 17.9163 22 16.5786 22 15.158C22 13.5903 21.5638 12.1236 20.8051 10.8707Z"
      fill={props.color}
    />
  </Icon>
);

export default CourseLanguage;
